import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';

@Component({
  selector: 'app-top-navbar',
  templateUrl: './top-navbar.component.html',
  styleUrls: ['./top-navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopNavbarComponent {
  private settingsService = inject(SettingsService);

  public readonly title = input<string>(undefined!);

  public settings = this.settingsService.settings;
}
